<template>
  <div class="profile-wrapper">
    <div class="sidebar">
      <div class="text-center">
        <router-link :to="{ name: 'main' }">
          <b-img
            v-if="userData.client && userData.client.logo"
            :src="userData.client.logo"
            alt="Client Logo"
            class="img-fluid p-3"
            style="max-width: 200px; max-height: 150px; object-fit: contain;"
          />
          <b-img
            v-else
            :src="require('../assets/logo-2-dark.png')"
            alt="To Be Legacy"
            class="img-fluid p-3"
            style="max-width: 200px;"
          />
        </router-link>
        <b-img
          v-if="userData.profile_picture"
          :src="userData.profile_picture"
          rounded="circle"
          width="176"
          alt
          class="img-fluid p-3"
          style="cursor: pointer"
          @click="$router.push({ name: 'edit_account' })"
          @error="$event.target.src = require('../assets/avatar-default.png')"
        />
        <b-img
          v-else
          :src="require('../assets/avatar-default.png')"
          rounded="circle"
          width="176"
          alt
          class="img-fluid p-3"
          style="cursor: pointer"
          @click="$router.push({ name: 'edit_account' })"
        />
        <p style="font-weight: 500;">
          {{ userData.first_name }} {{ userData.last_name }}
        </p>
      </div>

      <hr>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.fullPath === '/profile/' }"
            :to="{ name: 'main' }"
          >
            Legacy Library
          </router-link>
        </li>
        <li
          v-if="!userData.client"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.fullPath === '/journals' }"
            :to="{ name: 'journals' }"
          >
            My Journals
          </router-link>
        </li>
        <li
          v-if="!userData.client"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.fullPath === '/program/living_in_excellence' }"
            :to="{ name: 'living_in_excellence' }"
          >
            Living in Excellence
          </router-link>
        </li>
        <li
          v-if="!userData.client"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.fullPath === '/ask-a-coach' }"
            :to="{ name: 'ask_a_coach' }"
          >
            Ask A Coach
          </router-link>
        </li>
        <li
          v-if="!userData.client"
          class="nav-item"
        >
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.fullPath === '/page/apply-for-personal-coaching' }"
            :to="{ name: 'flatpage', params: { slug: 'apply-for-personal-coaching' }}"
          >
            Apply for Personal Coaching
          </router-link>
        </li>
        <li
          v-if="!userData.client"
          class="nav-item"
        >
          <router-link
            class="nav-link disabled"
            :class="{ 'active': $router.currentRoute.fullPath === '/store-and-media' }"
            :to="{ name: 'main' }"
          >
            Store/Media
          </router-link>
        </li>
      </ul>

      <template v-if="!userData.client">
        <hr>

        <ul class="nav flex-column">
          <li class="nav-item">
            <router-link
              class="nav-link"
              :class="{ 'active': $router.currentRoute.fullPath === '/page/partner-with-us' }"
              :to="{ name: 'flatpage', params: { slug: 'partner-with-us' }}"
            >
              Partner With Us
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :class="{ 'active': $router.currentRoute.fullPath === '/page/tbl-live-events' }"
              :to="{ name: 'flatpage', params: { slug: 'tbl-live-events' }}"
            >
              TBL Live Events
            </router-link>
          </li>
        </ul>
      </template>

      <hr>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.fullPath === '/edit_account' }"
            :to="{ name: 'edit_account' }"
          >
            Manage Account
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.name === 'notifications' }"
            :to="{ name: notificationsRouteName }"
          >
            Notifications
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{ 'active': $router.currentRoute.fullPath === '/logout' }"
            :to="{ name: 'logout' }"
          >
            Logout
          </router-link>
        </li>
      </ul>
    </div>

    <div class="mobile-navbar">
      <router-link :to="{ name: 'main' }">
        <b-img
          v-if="userData.client && userData.client.logo"
          :src="userData.client.logo"
          alt="Client Logo"
          class="logo"
          style="max-height: 50px; object-fit: contain;"
        />
        <img
          v-else
          src="../assets/logo-2-dark.png"
          alt="To Be Legacy"
          class="logo"
        >
      </router-link>
      <nav class="navbar navbar-light background-primary d-flex">
        <b-button
          v-b-toggle.collapse-1
          class="navbar-toggler bg-white mt-0"
        >
          <span class="navbar-toggler-icon" />
        </b-button>
        <div>
          <p
            style="font-weight: 500;"
            class="text-white mb-0 d-inline mr-2"
          >
            {{ userData.first_name }} {{ userData.last_name }}
          </p>
          <b-img
            v-if="userData.profile_picture"
            :src="userData.profile_picture"
            rounded="circle"
            alt
            class="img-fluid"
            style="width: 50px; cursor: pointer;"
            @click="$router.push({ name: 'edit_account' })"
            @error="$event.target.src = require('../assets/avatar-default.png')"
          />
          <b-img
            v-else
            :src="require('../assets/avatar-default.png')"
            rounded="circle"
            :width="100"
            alt
            class="img-fluid"
            style="cursor: pointer;"
            @click="$router.push({ name: 'edit_account' })"
          />
        </div>
      </nav>
      <b-collapse
        id="collapse-1"
        v-model="visible"
        class="background-gradient"
      >
        <div>
          <ul class="nav flex-column">
            <li
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/profile/' }"
                :to="{ name: 'main' }"
              >
                Legacy Library
              </router-link>
            </li>
            <li
              v-if="!userData.client"
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/journals' }"
                :to="{ name: 'journals' }"
              >
                My Journals
              </router-link>
            </li>
            <li
              v-if="!userData.client"
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/program/living_in_excellence' }"
                :to="{ name: 'living_in_excellence' }"
              >
                Living in Excellence
              </router-link>
            </li>
            <li
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/ask-a-coach' }"
                :to="{ name: 'ask_a_coach' }"
              >
                Ask A Coach
              </router-link>
            </li>
            <li
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/page/apply-for-personal-coaching' }"
                :to="{ name: 'flatpage', params: { slug: 'apply-for-personal-coaching' }}"
              >
                Apply for Personal Coaching
              </router-link>
            </li>
            <li
              v-if="!userData.client"
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link disabled"
                :class="{ 'active': $router.currentRoute.fullPath === '/store-and-media' }"
                :to="{ name: 'main' }"
              >
                Store/Media
              </router-link>
            </li>
          </ul>

          <hr>

          <ul class="nav flex-column">
            <li
              v-if="!userData.client"
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/page/partner-with-us' }"
                :to="{ name: 'flatpage', params: { slug: 'partner-with-us' }}"
              >
                Partner With Us
              </router-link>
            </li>
            <li
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/page/tbl-live-events' }"
                :to="{ name: 'flatpage', params: { slug: 'tbl-live-events' }}"
              >
                TBL Live Events
              </router-link>
            </li>
          </ul>

          <hr>

          <ul class="nav flex-column">
            <li
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/edit_account' }"
                :to="{ name: 'edit_account' }"
              >
                Manage Account
              </router-link>
            </li>
            <li
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.name === 'notifications' }"
                :to="{ name: notificationsRouteName }"
              >
                Notifications
              </router-link>
            </li>
            <li
              class="nav-item"
              @click="visible=false"
            >
              <router-link
                class="nav-link"
                :class="{ 'active': $router.currentRoute.fullPath === '/logout' }"
                :to="{ name: 'logout' }"
              >
                Logout
              </router-link>
            </li>
          </ul>
        </div>
      </b-collapse>
    </div>

    <!-- Mobile Header for Small Screens -->
    <header class="mobile-header">
      <div class="mobile-header-left">
        <button
          v-if="$route.name !== 'main' && $route.name !== 'client-main'"
          type="button"
          class="back-button-mobile"
          aria-label="Go back"
          @click="onMobileHeaderBack"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M19 12H5M12 19l-7-7 7-7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <router-link
          :to="{ name: 'main' }"
          class="header-logo"
        >
          <b-img
            v-if="userData.client && userData.client.logo"
            :src="userData.client.logo"
            alt="Client Logo"
            class="client-logo"
            style="max-height: 40px; object-fit: contain;"
          />
          <img
            v-else
            src="../assets/logo-2-dark.png"
            alt="To Be Legacy"
            class="client-logo"
          >
        </router-link>
      </div>

      <button
        type="button"
        class="header-profile"
        aria-label="Edit account"
        @click="$router.push({ name: 'edit_account' })"
      >
        <b-img
          v-if="userData.profile_picture"
          :src="userData.profile_picture"
          rounded="circle"
          alt="Profile"
          class="profile-pic"
          @error="$event.target.src = require('../assets/avatar-default.png')"
        />
        <b-img
          v-else
          :src="require('../assets/avatar-default.png')"
          rounded="circle"
          alt="Profile"
          class="profile-pic"
        />
        <span class="profile-name">{{ userData.first_name }}</span>
      </button>
    </header>

    <!-- Bottom Navigation Bar for Mobile -->
    <nav class="bottom-nav-bar">
      <router-link
        :to="{ name: mainRouteName }"
        class="bottom-nav-item"
        :class="{ active: isActiveRoute(['main', 'client-main']) }"
        aria-label="Home"
      >
        <div class="nav-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            />
            <polyline points="9,22 9,12 15,12 15,22" />
          </svg>
        </div>
        <span class="nav-label">Home</span>
      </router-link>

      <router-link
        :to="{ name: journalsRouteName }"
        class="bottom-nav-item"
        :class="{ active: isActiveRoute(['journals', 'client-journals']) }"
        aria-label="Journals"
      >
        <div class="nav-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14,2 14,8 20,8" />
            <line
              x1="16"
              y1="13"
              x2="8"
              y2="13"
            />
            <line
              x1="16"
              y1="17"
              x2="8"
              y2="17"
            />
            <polyline points="10,9 9,9 8,9" />
          </svg>
        </div>
        <span class="nav-label">Journals</span>
      </router-link>

      <router-link
        :to="{ name: excellenceRouteName }"
        class="bottom-nav-item"
        :class="{ active: isActiveRoute(['living_in_excellence', 'client-living_in_excellence']) }"
        aria-label="Living in Excellence"
      >
        <div class="nav-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
          </svg>
        </div>
        <span class="nav-label">Excellence</span>
      </router-link>

      <router-link
        :to="{ name: coachRouteName }"
        class="bottom-nav-item"
        :class="{ active: isActiveRoute(['ask_a_coach', 'client-ask_a_coach']) }"
        aria-label="Ask a Coach"
      >
        <div class="nav-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </div>
        <span class="nav-label">Coach</span>
      </router-link>
    </nav>

    <main>
      <router-view />
    </main>

    <choose-wave-modal
      v-if="showWaveModal && waveEnrollment"
      :enrollment-id="waveEnrollment.id"
      :program-title="waveEnrollment.program_title || waveEnrollment.title"
      @wave-selected="handleWaveSelected"
    />
  </div>
</template>

<script>
import api from '@/utils/api';
import ProgramsMixin from '@/mixins/Programs.vue';
import CoursesMixin from '@/mixins/Courses.vue';
import ChooseWaveModal from '@/components/ChooseWaveModal.vue';

export default {
  name: 'Profile',
  components: {
    ChooseWaveModal,
  },
  mixins: [CoursesMixin, ProgramsMixin],
  props: {
    clientSlug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      showWaveModal: false,
      waveEnrollment: null,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    programs() {
      return this.$store.state.programs;
    },
    mainRouteName() {
      return this.clientSlug ? 'client-main' : 'main';
    },
    journalsRouteName() {
      return this.clientSlug ? 'client-journals' : 'journals';
    },
    excellenceRouteName() {
      return this.clientSlug ? 'client-living_in_excellence' : 'living_in_excellence';
    },
    coachRouteName() {
      return this.clientSlug ? 'client-ask_a_coach' : 'ask_a_coach';
    },
    notificationsRouteName() {
      return this.clientSlug ? 'client-notifications' : 'notifications';
    },
  },
  watch: {
    // 1. If the User Data changes (Login/Logout), re-fetch immediately
    userData: {
      handler(newVal) {
        if (newVal) {
          // We have a user, get their specific programs
          this.fetchData();
          // Set client color for sidebar
          this.setClientColor();
        } else {
          // User logged out, clear client color
          this.clearClientColor();
        }
      },
      deep: true,
    },
    // 2. If the URL changes (switching clients), re-fetch
    clientSlug: {
      handler() {
        this.fetchData();
      },
    },
  },
  async created() {
    await this.fetchData();
    this.setClientColor();
  },
  mounted() {
    // Refresh client once on load (e.g. color from admin) without triggering a loop
    this.refreshClientData();
    this.setClientColor();
  },
  methods: {
    onMobileHeaderBack() {
      if (this.$store.state.activeJournalCategory !== null) {
        this.$store.commit('activeJournalCategory', null);
        this.$store.commit('activeJournalProgram', null);
        return;
      }
      this.$router.go(-1);
    },
    async fetchData() {
      // Check if user needs to pick a wave for any new enrollments
      await this.checkWaveRequirements();
      // await this.fetchCourses();
      await this.fetchPrograms(this.clientSlug);
    },
    async refreshClientData() {
      if (!this.userData || !this.userData.client || !this.userData.client.slug) return;
      try {
        const response = await api({
          url: `clients/${this.userData.client.slug}/`,
          method: 'GET',
        });
        if (response.ok) {
          const clientData = response.body;
          this.$store.commit('client', clientData);
          this.$store.commit('userData', { ...this.userData, client: clientData });
          this.setClientColor();
        }
      } catch (e) {
        // Non-fatal: keep existing client data
      }
    },
    async checkWaveRequirements() {
      if (!this.userData) return;

      try {
        const response = await api({
          url: `users/${this.userData.id}/enrollments/`,
          method: 'GET',
          headers: { Authorization: `Token ${this.userData.drf_token}` },
        });

        if (response.ok) {
          // 1. Filter for enrollments that need wave selection
          // Only show modal for pending_wave status - active enrollments without waves
          // have already selected "Go at your own pace"
          const pendingEnrollments = response.body.filter(
            e => !e.wave && e.status === 'pending_wave',
          );

          if (pendingEnrollments.length === 0) return;

          // 2. Show modal for first enrollment without a wave
          // Users can select "Go at your own pace" or choose from available waves
          [this.waveEnrollment] = pendingEnrollments;
          this.showWaveModal = true;
        }
      } catch (e) {
        // Error checking wave requirements - silently handle
      }
    },
    handleWaveSelected() {
      // Close modal immediately - set both to ensure v-if evaluates to false
      this.showWaveModal = false;
      this.waveEnrollment = null;

      // Refresh the programs list to ensure UI updates (e.g. unlocks content)
      this.fetchPrograms(this.clientSlug);

      // Wait a bit before checking for other enrollments to ensure modal closes first
      setTimeout(() => {
        // Recursively check if there are OTHER enrollments needing a wave
        this.checkWaveRequirements();
      }, 100);
    },
    setClientColor() {
      if (this.userData && this.userData.client) {
        // Check for various possible color property names
        const color = this.userData.client.color
          || this.userData.client.primary_color
          || this.userData.client.primaryColor;

        if (color) {
          document.documentElement.style.setProperty('--primary-color', color);
        } else {
          // Clear if no color specified
          this.clearClientColor();
        }
      } else {
        this.clearClientColor();
      }
    },
    clearClientColor() {
      document.documentElement.style.removeProperty('--primary-color');
    },
    isActiveRoute(routeNames) {
      return routeNames.includes(this.$route.name);
    },
  },
};
</script>
